.footer {
  justify-content: space-between;
  width: 100%;
}
